import { Plus } from '@styled-icons/feather';
import { NavbarDropdown } from '@typedream/core';
import { useActor } from '@xstate/react';
import styled from 'styled-components';
import { InterpreterFrom } from 'xstate';
import { useTPlateEditorRef } from '../../../../../plate';
import { navbarDropdownContainerFSM } from '../finiteStateMachines/NavbarDropdownContainer.fsm';
import { getSelectedNavbarItem } from '../utils';

// ======================================================
// STYLED COMPONENT
// ======================================================
const DivContainer = styled.div<{ isCard: boolean }>`
  bottom: -64px;
  left: 0;
  height: 64px;
  padding-top: 16px;
  display: flex;
  gap: 20px;
  pointer-events: auto;
  padding-left: ${({ isCard }) => (isCard ? 0 : 20)}px;
`;

const SettingButton = styled.div`
  padding: 12px 16px;
  white-space: nowrap;
  border-radius: 6px;
  background-color: var(--background-button);
  box-shadow: var(--shadow-button);
  cursor: pointer;
`;

const BottomOptionStyleDiv = styled.div<{ isActive: boolean }>`
  display: inline-block;
  margin: -6px 0;
  padding: 6px 12px;
  cursor: pointer;
  border-radius: 4px;
  background: ${({ isActive }) => (isActive ? 'var(--accent-light)' : 'transparent')};
  color: ${({ isActive }) => (isActive ? 'var(--accent)' : 'var(--text-lighter)')};

  &:first-of-type {
    margin-left: 24px;
  }
`;
// ======================================================
// STYLED COMPONENT END
// ======================================================

const CARD_MODE_MAX_COLUMN = 2;

interface BottomOptionsProps {
  machineService: InterpreterFrom<typeof navbarDropdownContainerFSM>;
}

function BottomOptions(props: BottomOptionsProps) {
  const { machineService } = props;

  const [machineState, machineSend] = useActor(machineService);

  const currentMenu = getSelectedNavbarItem<NavbarDropdown>(machineState.context);
  const isDisableAddColumn =
    currentMenu?.menu.style === 'card' && currentMenu?.menu.children.length >= CARD_MODE_MAX_COLUMN;

  const editor = useTPlateEditorRef();
  const preventShowingNavbarContainerToolbar = () => {
    editor.emitter.emit('toolbar:toggle-navbar-container-inside-dropdown', { isInside: true });
  };

  return (
    <DivContainer
      isCard={currentMenu?.menu.style === 'card'}
      onMouseEnter={preventShowingNavbarContainerToolbar}
    >
      <SettingButton style={{ paddingLeft: 24, cursor: 'default' }}>
        Style
        <BottomOptionStyleDiv
          isActive={currentMenu?.menu.style === 'big-box'}
          role="none"
          onClick={() => machineSend({ type: 'ON_CHANGE_STYLE', style: 'big-box' })}
        >
          Big Box
        </BottomOptionStyleDiv>
        <BottomOptionStyleDiv
          isActive={currentMenu?.menu.style === 'card'}
          onClick={() => machineSend({ type: 'ON_CHANGE_STYLE', style: 'card' })}
          role="none"
        >
          Card
        </BottomOptionStyleDiv>
      </SettingButton>
      <SettingButton
        role="button"
        tabIndex={0}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          paddingLeft: 24,
          paddingRight: 24,
          cursor: isDisableAddColumn ? 'not-allowed' : undefined,
          color: isDisableAddColumn ? 'var(--text-lighter2)' : undefined,
        }}
        onClick={isDisableAddColumn ? undefined : () => machineSend({ type: 'ON_ADD_COLUMN' })}
      >
        <Plus size={15} className="mr-3" />
        Add Column
      </SettingButton>
      <SettingButton
        role="button"
        tabIndex={0}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          paddingLeft: 24,
          paddingRight: 24,
        }}
        onClick={() => machineSend({ type: 'ON_ADD_COLUMN_ITEM' })}
      >
        <Plus size={15} className="mr-3" />
        Add Item
      </SettingButton>
    </DivContainer>
  );
}

export default BottomOptions;
